const profiles = [
  {
    name: "FURQAN AZIZ",
    designation: "Chief Executive Officer",
    imgSrc: "https://invozone.com/wp-content/uploads/2020/05/ceo.svg",
    skypeLink: "skype:furqanaziz786?call",
    linkedInLink: "https://www.linkedin.com/in/furqan-aziz",
  },
  {
    name: "HAREEM MOHSIN",
    designation: "Chief Operating Officer",
    imgSrc: "https://invozone.com/wp-content/uploads/2020/05/coo.svg",
    skypeLink: "skype:hareemfurqan86?call",
    linkedInLink: "https://www.linkedin.com/in/hareem-mohsin-878500194/",
  },
  {
    name: "ZARNOOR SHOAIB",
    designation: "Head of BD",
    imgSrc: "https://invozone.com/wp-content/uploads/2020/05/bd.svg",
    skypeLink: "skype:bd_invozone?call",
    linkedInLink:
      "https://www.linkedin.com/in/muhammad-zarnoor-shoaib-7a8b6782/",
  },
  {
    name: "ANNA LEUSDER",
    designation: "Head of Client Success",
    imgSrc: "https://invozone.com/wp-content/uploads/2020/05/anna.svg",
    skypeLink: "skype:annaleusder_1?call",
    linkedInLink: "https://www.linkedin.com/in/anna-leusder-753bb851/",
  },
  {
    name: "MUHAMMAD SHAH JAHAN",
    designation: "General Manager",
    imgSrc: "https://invozone.com/wp-content/uploads/2020/05/gm.svg",
    skypeLink: "skype:shahjaaan89?call",
    linkedInLink: "https://www.linkedin.com/in/shahjhan89/",
  },
  {
    name: "MUHAMMAD SAAD",
    designation: "Head of HR",
    imgSrc: "https://invozone.com/wp-content/uploads/2020/05/ht.svg",
    skypeLink: "skype:HR_InvoZone?call",
    linkedInLink: "https://au.linkedin.com/in/m-saad-58b83960",
  },
  {
    name: "MOHTASHIM RASHEED",
    designation: "Head of Engineering",
    imgSrc: "https://invozone.com/wp-content/uploads/2020/05/pm.svg",
    skypeLink: "skype:mohtashim66?call",
    linkedInLink: "https://www.linkedin.com/in/mohtashim-rasheed-1aa13aab/",
  },
  {
    name: "MUHAMMAD ZUBAIR",
    designation: "Head of UI/UX",
    imgSrc: "https://invozone.com/wp-content/uploads/2020/05/ui.svg",
    skypeLink: "skype:itszubairzabi?call",
    linkedInLink: "https://linkedin.com/in/itszubairzabi/",
  },
];

export default profiles;
